import React, { useEffect, useState } from "react";

import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Grid,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Fade,
  Box,
  Stepper,
  Step,
  StepLabel,
  Alert,
} from "@mui/material/";

import { CommonSubHeader } from "../../Components/helpers/Helpers";

import EditarCliente from "../../Clientes/Crud/Editar";
import {
  Info,
  ExpandMore,
  ExpandLess,
  Close,
  Visibility,
  ArrowForwardIos,
  TransferWithinAStation,
  Cases,
  MoveDown,
} from "@mui/icons-material";
import Expedientes from "../Expedientes";
import CrearExpediente from "./Crear";
import api from "../../api/axios";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";
import { useContext } from "react";
import { UserContext } from "../../Components/Context/Context";

const Transferir = () => {
  const Swal = require("sweetalert2");
  const navigate = useNavigate();

  // TAKE ZONES DATA
  // SAVE URL
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("id");
  const { userData } = useContext(UserContext);

  // TAKE VALUES
  const [clientTransferData, setClientTransferData] = useState({
    email: "",
    name: "",
    surname: "",
    address: "",
    postalcode: "",
    document: "",
    phone: "",
    observations: "",
    province: {},
    company: {},
    association: {},
    zone: {},
    status: {},
    // office: {},
    cards: {},
  });

  const principalButtons = [
    {
      id: 1,
      principalTitle: "TRANSFERIR CLIENTE",
    },
    {
      id: 2,
      principalTitle: "TRANSFERIR EXPEDIENTE",
    },
  ];

  const steps = [
    {
      id: 1,
      title: "PASO 1 (Si no se ha transferido el cliente)",
      subtitle: "TRANSFERIR CLIENTE:",
      items: [
        "El cliente puede transferirse una única vez por cada empresa seleccionada.",
        "La información aquí editada no afectará la información original del cliente.",
        "Toda la información del cliente será guardada con los cambios que se hayan editado en esta sección.",
        "El proceso es totalmente transparente para el cliente.",
      ],
      label: "Cliente",
    },
    {
      id: 2,
      title: "PASO 2 (Si ya se ha transferido el cliente)",
      subtitle: "TRANSFERIR EXPEDIENTE:",
      label: "Expedientes",
      items: [
        "Las empresas en las que está creado el cliente se visualizarán en el primer apartado.",
        "Se habilitará la sección TRANSFERIR EXPEDIENTES, contigua al botón TRANSFERIR CLIENTE.",
        "Una vez transferido el cliente, se mostrará el panel con los expedientes disponibles para transferir.",
        `Cada expediente podrá transferirse haciendo clic en el botón ubicado al final de la tabla, llamado "TRANSFERIR EXPEDIENTE".`,
      ],
    },
  ];

  const [principalCase, setPrincipalCase] = useState([]);

  const [openClients, setOpenClients] = useState(true);
  const [openCases, setOpenCases] = useState(false);

  const [multipleClients, setMultipleClients] = useState([]);
  const [multipleCases, setMultipleCases] = useState([]);
  const [caseCreated, setCaseCreated] = useState(false);
  const [selectedDataNewCase, setSelectedDataNewCase] = useState([]);

  const [transferedClientsInfo, setTransferedClientsInfo] = useState([]);
  const [actualClientinfo, setActualClientinfo] = useState([]);

  const [currentClientTransfer, setCurrentClientTransfer] = useState([]);
  const [dataClientTransfered, setDataClientTransfered] = useState([]);
  const [clientCreated, setClientCreated] = useState(false);

  // MODAL CASE TRANSFER
  const [openCaseTransferModal, setOpenCaseTransferModal] = useState(false);
  const [valueRadioCaseTransfer, setValueRadioCaseTransfer] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const stepsCasesTransfer = [
    "Seleccionar empresa a transferir",
    // "Agregar detalles adicionales",
  ];

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleOpenCaseTransferModal = () => setOpenCaseTransferModal(true);
  const handleCloseCaseTransfer = () => {
    setValueRadioCaseTransfer("");
    setOpenCaseTransferModal(false);
    setActiveStep(0);
  };
  // MODAL CASE TRANSFER

  const handleCasesTransfer = async (data) => {
    // if (!data?.transfer_id) return;
    console.log(data);
    setPrincipalCase(data);

    // Mostrar loading con Swal
    Swal.fire({
      title: "Cargando información del expediente...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      console.log(data.transfer_id);
      var parsedIds = JSON.parse(data.transfer_id ? data.transfer_id : null);

      if (typeof parsedIds === "number") {
        parsedIds = [data.transfer_id];
      }

      console.log(parsedIds);

      if (!Array.isArray(parsedIds) || parsedIds.length === 0) {
        setMultipleCases([]);
        console.log("entra");

        Swal.close(); // Cerrar loading si no hay IDs válidos
      } else {
        const caseIdObjects = parsedIds?.map((id) => ({ id }));

        console.log("caseIdObjects", caseIdObjects);

        const response = await api.post(
          `${process.env.REACT_APP_API_URL}/cases/search`,
          {
            cases: caseIdObjects,
          },
        );

        const getCases = response?.data?.multiple;

        console.log("getCases", getCases);
        console.log("userData", userData);

        setMultipleCases(
          Array.isArray(getCases) && getCases?.length > 0 ? getCases : [],
        );

        Swal.close(); // Cerrar loading antes de mostrar el modal
      }

      handleOpenCaseTransferModal();
    } catch (error) {
      console.error("Error cargando expedientes múltiples:", error);

      // Mostrar error con Swal
      Swal.fire({
        icon: "error",
        title: "Error al cargar los casos",
        text: "Ocurrió un problema al intentar cargar los expedientes.",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  const handleTransferCase = () => {
    console.log(transferedClientsInfo, "transferedClientsInfo");
    if (valueRadioCaseTransfer != "" && valueRadioCaseTransfer) {
      let getTransferedClient = transferedClientsInfo?.find((item) => {
        console.log(item?.id, Number(valueRadioCaseTransfer));
        return item?.company_id === Number(valueRadioCaseTransfer);
      });

      console.log("getTransferedClient", getTransferedClient);
      console.log("principalCase", principalCase);

      const dataNewCase = {
        id_fisico: principalCase?.id_fisico || "",
        company_id: Number(valueRadioCaseTransfer) || 0,
        // office_id: Number(principalCase?.office_id) || 0,
        user_id: Number(getTransferedClient?.lawyer) || 0,
        inss_users: principalCase?.inss_users || "",
        client_id: Number(getTransferedClient?.id) || 0,
        case_type: Number(principalCase?.case_type) || 0,
        case_contract: Number(principalCase?.case_contract) || 0,
        case_status: Number(principalCase?.case_status) || 0,
        transfer_id: Number(principalCase?.id),
        // case_office_id: Number(principalCase?.case_office_id) || 0,
        extra_data: principalCase?.extra_data || null,
        date_in: principalCase?.date_in || "",
        last_update: principalCase?.last_update || "",
        peritaje: principalCase?.peritaje || null,
        apud_acta: principalCase?.apud_acta || null,
      };

      console.log("dataNewCase", dataNewCase);

      setDataClientTransfered(dataNewCase);
      const queryUrl = `${process.env.REACT_APP_API_URL}/cases/transfer`;

      Swal.fire({
        title: "¿Desea guardar los cambios?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Volver`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            //   Mostrar carga mientras se hace la petición
            Swal.fire({
              title: "Guardando...",
              text: "Por favor espere un momento",
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            const response = await api.post(queryUrl, dataNewCase);
            console.log(response);

            Swal.close(); //   Cerrar el swal de carga

            if (response.data.error) {
              Swal.fire({
                title: "¡No se guardaron los cambios!",
                icon: "error",
                text: "Por favor inténtelo nuevamente",
                confirmButtonColor: "#1ab394",
              });
            } else {
              Swal.fire({
                title: "¡Guardado!",
                icon: "success",
                confirmButtonColor: "#1ab394",
                allowEscapeKey: false,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  setCaseCreated(response);
                  handleCloseCaseTransfer();
                }
              });
            }
          } catch (error) {
            Swal.close(); // Cierra el loading si hay error
            console.error(error);
          }
        } else if (result.isDenied) {
          Swal.fire("¡Los cambios no han sido guardados!", "", "info");
        }
      });
    } else {
      Swal.fire({
        title: "Por favor seleccione una empresa",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
    }
  };

  const handleChangeRadioCasesTransfer = (event) => {
    setValueRadioCaseTransfer(event.target.value);
  };

  const handleClientTransfer = async () => {
    console.log(clientTransferData);
    let requiredFields = {
      // id: clientId ?? 0,
      name: clientTransferData?.name?.trim() || "",
      surname: clientTransferData?.surname?.trim() || "",
      address: clientTransferData?.address?.trim() || "",
      postalcode: clientTransferData?.postalcode?.trim() || "",
      nif: clientTransferData?.document?.trim() || "",
      phone: clientTransferData?.phone?.trim() || "",
      province: clientTransferData?.province?.provincia || "",
      lawyer: clientTransferData?.lawyer?.id || 0,
      company_id: clientTransferData?.company?.id || 0,
      status:
        clientTransferData?.status?.id && clientTransferData.status.id !== -1
          ? clientTransferData.status.id
          : 0,
    };

    const optionalFields = {
      // office: clientTransferData?.office?.id || 0,
      asociation: clientTransferData?.association?.id || 0,
      zone: clientTransferData?.zone?.id || 0,
    };

    // Combinar si lo necesitas luego
    const fields = { ...requiredFields, ...optionalFields };

    if (fields?.company_id == 0) {
      Swal.fire({
        title: "¡Por favor seleccione una empresa!",
        icon: "warning",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    } else {
      //  Validar todos los campos (sin email)
      requiredFields = Object.keys(requiredFields);
      const missingFields = requiredFields.filter(
        (field) =>
          fields[field] === undefined ||
          fields[field] === null ||
          fields[field] === "" ||
          fields[field] === 0,
      );

      if (missingFields.length === 0) {
        const formData = new FormData();
        Object.entries(fields).forEach(([key, value]) => {
          formData.append(key, value);
        });

        const confirmResult = await Swal.fire({
          title: "¿Desea guardar los cambios?",
          icon: "warning",
          showDenyButton: true,
          confirmButtonColor: "#1ab394",
          cancelButtonColor: "#d33",
          reverseButtons: true,
          confirmButtonText: "Guardar",
          denyButtonText: "Volver",
        });

        if (confirmResult.isConfirmed) {
          try {
            // 🌀 Mostrar swal de carga
            Swal.fire({
              title: "Guardando cliente...",
              text: "Por favor espere un momento",
              allowOutsideClick: false,
              allowEscapeKey: false,
              didOpen: () => Swal.showLoading(),
            });

            const response = await api.post(
              `${process.env.REACT_APP_API_URL}/users/store`,
              formData,
            );

            Swal.close(); //    cerrar spinner

            const client_created = response?.data?.client_created?.id;

            if (client_created) {
              Swal.fire({
                title: "Cliente creado",
                icon: "success",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((res) => {
                if (res.isConfirmed) {
                  setClientCreated(!clientCreated);
                }
                setOpenClients(false);
                setOpenCases(true);
              });
            }
          } catch (error) {
            Swal.close(); // asegurarse de cerrar la carga
            Swal.fire({
              title: "Error",
              icon: "error",
              text: "Hubo un problema al guardar el cliente.",
              confirmButtonColor: "#1ab394",
            });
            console.error("Error al crear cliente:", error);
          }
        } else if (confirmResult.isDenied) {
          Swal.fire({
            title: "Los cambios no han sido guardados",
            icon: "error",
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Continuar",
          });
        }
      } else {
        const fieldNames = {
          lawyer: "Abogado",
          name: "Nombre",
          surname: "Apellido",
          address: "Dirección",
          asociation: "Asociación",
          postalcode: "Código Postal",
          company_id: "Empresa",
          nif: "Documento",
          phone: "Teléfono",
          province: "Provincia",
          // office: "Despacho",
          status: "Estado",
          zone: "Zona",
        };

        const missingFieldsList = missingFields
          .map((field) => `<li>${fieldNames[field] || field}</li>`)
          .join("");

        Swal.fire({
          title: '<strong style="color: #f27474"> ¡Error! </strong>',
          icon: "error",
          html: `Por favor, rellene los siguientes campos:<ul style="text-align: left;">${missingFieldsList}</ul>`,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Continuar",
        });
      }
    }
  };

  // useEffect(() => {
  //   console.log(selectedDataNewCase);
  // }, [selectedDataNewCase]);
  console.log(actualClientinfo[0]?.company_id != 1);
  console.log(transferedClientsInfo);

  return (
    <div>
      <div className="fatherContainer">
        <CommonSubHeader
          title="Clientes"
          subTitle="Transferir Cliente - Expediente"
        />
      </div>

      {transferedClientsInfo?.length > 0 &&
      actualClientinfo[0]?.company_id != 1 ? (
        <Alert color="error">
          El cliente/expediente no se puede transferir debido a que no
          corresponde a la empresa Fidelitis.
        </Alert>
      ) : (
        <Grid container sx={{ textAlign: "center" }}>
          {principalButtons.map((step, idx) => (
            <Grid
              key={`step-${step.id ?? idx}`} // Usa el ID si existe, si no, usa el índice
              item
              xs={5.5}
              sx={{
                boxShadow:
                  "0px 0px 15px 0px" +
                  (step?.id === 1 ? "#0288d161" : "#2e7d324a"),
                margin: "auto",
              }}>
              <Button
                color={step?.id === 1 ? "primary" : "success"}
                variant="outlined"
                size="small"
                sx={{
                  width: "100%",
                  fontWeight: "700",
                  background: "white",
                  height: "70px",
                }}
                onClick={() => {
                  if (step.id === 1) {
                    setOpenClients(!openClients);
                    setOpenCases(false);
                  } else if (
                    step.id === 2 &&
                    transferedClientsInfo?.length > 0
                  ) {
                    setOpenCases(!openCases);
                    setOpenClients(false);
                  }
                }}>
                {step?.id === 1 ? (
                  <TransferWithinAStation sx={{ mr: 1, mb: "2px" }} />
                ) : (
                  <MoveDown color="success" sx={{ mr: 1, mb: "2px" }} />
                )}
                {step.principalTitle}
                {step.id === 1 ? (
                  openClients ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : openCases ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </Button>
            </Grid>
          ))}

          {/* Collapse para CLIENTES */}
          <Collapse
            in={openClients}
            timeout="auto"
            unmountOnExit
            sx={{ width: "100%" }}>
            <Grid
              container
              justifyContent="center"
              style={{
                margin: "10px auto",
              }}>
              {steps
                .filter((s) => s.label === "Cliente")
                .map((step, idx) => {
                  const keyPrefix = `cliente-step-${step?.id ?? idx}`;
                  return (
                    <React.Fragment key={keyPrefix}>
                      <Grid
                        item
                        xs={5.5}
                        className="stepsContainer"
                        sx={{ border: "1px solid #0288d1" }}>
                        <div
                          style={{
                            color: "#0288d1",
                            display: "flex",
                            alignItems: "center",
                          }}>
                          <Info sx={{ mr: 1, mb: "2px" }} />
                          <b style={{ color: "#0288d1" }}>{step.title}</b>
                        </div>
                        <hr />
                        <b>{step.subtitle}</b>
                        <ul style={{ paddingLeft: "18px", textAlign: "left" }}>
                          {step.items.map((item) => (
                            <li key={item} style={{ marginBottom: "5px" }}>
                              {item}
                            </li>
                          ))}
                        </ul>
                      </Grid>

                      {multipleClients.length > 0 ? (
                        <Fade timeout={600} in>
                          <Grid
                            item
                            xs={5.5}
                            className="stepsContainer"
                            sx={{ border: "1px solid #0288d1" }}>
                            <Grid item xs={12}>
                              <div
                                style={{
                                  color: "#0288d1",
                                  display: "flex",
                                  alignItems: "center",
                                }}>
                                <Info sx={{ mr: 1, mb: "2px" }} />
                                <b style={{ color: "#0288d1" }}>
                                  Existencia del cliente en las diferentes
                                  empresas:
                                </b>
                              </div>
                              <hr />
                              {transferedClientsInfo?.length > 0 && (
                                <ul>
                                  {transferedClientsInfo.map(
                                    (company, index) => (
                                      <li key={`company-${index}`}>
                                        <b
                                          style={{
                                            color:
                                              "rgba(0, 0, 0, 0.5803921569)",
                                          }}>
                                          {company?.company_name?.toUpperCase()}
                                        </b>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              )}
                            </Grid>
                          </Grid>
                        </Fade>
                      ) : (
                        <Grid
                          item
                          xs={5.5}
                          className="stepsContainer"
                          sx={{ opacity: 0 }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
            </Grid>
            <EditarCliente
              transferCase={true}
              handleClientTransfer={handleClientTransfer}
              setClientTransferData={setClientTransferData}
              setTransferedClientsInfo={setTransferedClientsInfo}
              setActualClientinfo={setActualClientinfo}
              setMultipleClients={setMultipleClients}
              clientCreated={clientCreated}
              setCurrentClientTransfer={setCurrentClientTransfer}
            />
          </Collapse>

          {/* Collapse para EXPEDIENTES */}
          <Collapse
            in={openCases && transferedClientsInfo?.length > 0}
            timeout="auto"
            unmountOnExit
            sx={{ width: "100%" }}>
            <Grid container justifyContent="center">
              {steps
                .filter((s) => s.label === "Expedientes")
                .map((step, idx) => (
                  <Grid
                    sx={{ border: "1px solid #2e7d32" }}
                    item
                    xs={11.5}
                    key={`step-${step.id ?? step.title ?? idx}`}
                    className="stepsContainer">
                    <div
                      style={{
                        color: "#2e7d32",
                        display: "flex",
                        alignItems: "center",
                      }}>
                      <Info sx={{ mr: 1, mb: "2px" }} />
                      <b style={{ color: "#2e7d32" }}>{step.title}</b>
                    </div>
                    <hr />
                    <b>{step.subtitle}</b>
                    <ul style={{ paddingLeft: "18px", textAlign: "left" }}>
                      {step.items.map((item, i) => (
                        <li
                          key={`item-${i}-${item}`}
                          style={{ marginBottom: "5px" }}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </Grid>
                ))}
            </Grid>

            <Expedientes
              flagToShow={false}
              transferClient={clientTransferData}
              handleCasesTransfer={handleCasesTransfer}
              caseCreated={caseCreated}
              clientCreated={clientCreated}
              currentClientTransfer={currentClientTransfer}
            />
          </Collapse>

          {/* Modal Case Transfer  */}
          <Dialog
            open={openCaseTransferModal}
            onClose={handleCloseCaseTransfer}
            maxWidth="lg"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: "4px",
              },
            }}>
            <DialogTitle
              sx={{
                m: 0,
                p: 3,
                display: "flex",
                justifyContent: "space-between",
              }}>
              Transferir el expediente a diferentes empresas.
              <CustomButtonPlusIcon
                icon={Close}
                variant="outlined"
                color="error"
                handleFunction={handleCloseCaseTransfer}
              />
            </DialogTitle>

            {/* 🪜 Paso actual */}
            <Stepper activeStep={activeStep} sx={{ px: 3, pt: 2, pb: 3 }}>
              {stepsCasesTransfer.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <DialogContent dividers>
              {activeStep === 0 && (
                <>
                  <FormLabel component="legend">
                    El cliente está actualmente asociado a las siguientes
                    empresas. Por favor, seleccione la empresa a la que desea
                    transferirlo y haga clic en 'Continuar'.
                  </FormLabel>

                  <RadioGroup
                    aria-label="opciones"
                    name="opciones"
                    value={valueRadioCaseTransfer}
                    onChange={handleChangeRadioCasesTransfer}>
                    {transferedClientsInfo?.length > 0 && (
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {transferedClientsInfo.map((company, index) => {
                          const match = multipleCases?.find(
                            (caseItem) =>
                              caseItem?.company_id === company?.company_id,
                          );

                          if (match) {
                            company.case = match.id;
                            const lawyerName =
                              match.lawyers_relation?.name || "";
                            const lawyerSurname =
                              match.lawyers_relation?.surname || "";
                            company.lawyer =
                              `${lawyerName} ${lawyerSurname}`.trim();
                          }

                          return (
                            <li
                              key={
                                company?.company_id ??
                                `company-${Math.random()}`
                              }
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom:
                                  index !== transferedClientsInfo.length - 1
                                    ? "1px solid #cfcfd2"
                                    : "none",
                                padding: "8px 0",
                              }}>
                              <FormControlLabel
                                value={company?.company_id}
                                control={<Radio disabled={!!match?.id} />}
                                label={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}>
                                    {company?.company_name?.toUpperCase()}{" "}
                                    {match?.lawyer && (
                                      <>
                                        <ArrowForwardIos
                                          style={{
                                            height: "14px",
                                            verticalAlign: "middle",
                                          }}
                                        />{" "}
                                        Transferido a: {match.lawyer}
                                      </>
                                    )}
                                  </span>
                                }
                              />

                              <Box
                                sx={{ display: "flex", alignItems: "center" }}>
                                {match?.id ? (
                                  <Button
                                    color="success"
                                    variant="outlined"
                                    size="small"
                                    endIcon={<Visibility />}
                                    component={NavLink}
                                    to={`/expedientes/ver?id=${company.case}`}
                                    target="_blank">
                                    TRANSFERIDO - CASO # {company.case}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="small">
                                    SIN TRANSFERIR
                                  </Button>
                                )}
                              </Box>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </RadioGroup>
                </>
              )}

              {activeStep === 1 && (
                <Box>
                  <h3>Crear expediente</h3>

                  <CrearExpediente
                    setSelectedDataNewCase={setSelectedDataNewCase}
                    dataClientTransfered={dataClientTransfered}
                    transferState={true}
                  />

                  <p>
                    ¿Desea confirmar la transferencia del expediente a la
                    empresa seleccionada?
                  </p>
                </Box>
              )}
            </DialogContent>

            <DialogActions sx={{ m: 0, p: 3 }}>
              {activeStep > 0 && (
                <Button variant="outlined" onClick={handleBack}>
                  Atrás
                </Button>
              )}
              {activeStep == 0 && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleCloseCaseTransfer}>
                  Cancelar
                </Button>
              )}
              {activeStep === stepsCasesTransfer.length - 1 ? (
                <Button
                  onClick={handleTransferCase}
                  variant="contained"
                  color="success">
                  Confirmar
                </Button>
              ) : (
                <Button
                  onClick={handleNext}
                  variant="contained"
                  color="success"
                  disabled={!valueRadioCaseTransfer}>
                  Continuar
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </Grid>
      )}
    </div>
  );
};

export default Transferir;
